
import { AlertTriangle } from "lucide-react";

interface ErrorBannerProps {
  error: Error | null;
  visible: boolean;
}

const ErrorBanner = ({ error, visible }: ErrorBannerProps) => {
  if (!visible || !error) return null;
  
  return (
    <div className="mb-6 p-4 bg-red-50 border border-red-200 rounded-md flex items-center gap-3">
      <AlertTriangle className="h-5 w-5 text-red-500" />
      <p className="text-red-700">
        Error loading reagents: {error.message || "Unknown error"}
      </p>
    </div>
  );
};

export default ErrorBanner;
